const CHAT_TEXT_PATTERNS = [/chat/i, /chat with us/i];
const BUTTON_BASE_SIZE_PX = 48;
const CHAT_ICON_ONLY_CLASS = 'chat-icon-only-force';
const CHAT_TEXT_HIDDEN_CLASS = 'chat-icon-only-label';

/**
 * @param {Element} element
 * @returns {boolean}
 */
function isBottomRightFloating(element) {
  if (!(element instanceof HTMLElement)) return false;
  const style = window.getComputedStyle(element);
  if (style.position !== 'fixed') return false;
  const rect = element.getBoundingClientRect();
  const nearBottom = rect.bottom >= window.innerHeight - 140;
  const nearRight = rect.right >= window.innerWidth - 140;
  return nearBottom && nearRight;
}

/**
 * @param {Document | Element} root
 */
function makeChatButtonIconOnly(root = document) {
  const clickable = root.querySelectorAll('button, a, [role="button"]');
  clickable.forEach((node) => {
    if (!(node instanceof HTMLElement)) return;
    if (!isBottomRightFloating(node)) return;

    const visibleText = (node.textContent || '').trim();
    if (!CHAT_TEXT_PATTERNS.some((re) => re.test(visibleText))) return;
    if (!node.querySelector('svg, img')) return;

    node.querySelectorAll('span, div').forEach((child) => {
      if (!(child instanceof HTMLElement)) return;
      const childText = (child.textContent || '').trim();
      if (!CHAT_TEXT_PATTERNS.some((re) => re.test(childText))) return;
      if (child.querySelector('svg, img')) return;
      child.classList.add(CHAT_TEXT_HIDDEN_CLASS);
    });

    node.classList.add(CHAT_ICON_ONLY_CLASS);
    node.setAttribute('aria-label', visibleText || 'Chat');
  });
}

function clampChatIframeLauncherSize() {
  const iframeSelectors = [
    'iframe[id*="chat" i]',
    'iframe[title*="chat" i]',
    'iframe[src*="shopify" i][src*="inbox" i]',
  ];
  document.querySelectorAll(iframeSelectors.join(',')).forEach((frame) => {
    if (!(frame instanceof HTMLIFrameElement)) return;
    const rect = frame.getBoundingClientRect();
    const nearBottom = rect.bottom >= window.innerHeight - 140;
    const nearRight = rect.right >= window.innerWidth - 140;
    if (!nearBottom || !nearRight) return;

    frame.style.width = `${BUTTON_BASE_SIZE_PX}px`;
    frame.style.minWidth = `${BUTTON_BASE_SIZE_PX}px`;
    frame.style.height = `${BUTTON_BASE_SIZE_PX}px`;
    frame.style.borderRadius = '999px';
    frame.style.overflow = 'hidden';
  });
}

function initChatIconOnly() {
  makeChatButtonIconOnly(document);
  clampChatIframeLauncherSize();

  const observer = new MutationObserver(() => {
    makeChatButtonIconOnly(document);
    clampChatIframeLauncherSize();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  window.setInterval(() => {
    makeChatButtonIconOnly(document);
    clampChatIframeLauncherSize();
  }, 1500);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initChatIconOnly, { once: true });
} else {
  initChatIconOnly();
}
